export default __webpack_public_path__ + "static/media/view_img3.bbeaad8b.png";